'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaInr = function FaInr(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 10.5v2.3q0 0.3-0.2 0.5t-0.5 0.2h-3.7q-0.5 3.2-2.9 5.2t-6.2 2.5q3.8 3.9 10.3 11.9 0.3 0.4 0.1 0.8-0.2 0.4-0.7 0.4h-4.3q-0.4 0-0.6-0.3-6.8-8.2-11.1-12.7-0.2-0.2-0.2-0.5v-2.9q0-0.2 0.2-0.5t0.5-0.2h2.5q3 0 4.8-0.9t2.2-2.8h-9.5q-0.3 0-0.5-0.2t-0.2-0.5v-2.3q0-0.3 0.2-0.5t0.5-0.2h9.2q-1.2-2.5-6-2.5h-3.2q-0.3 0-0.5-0.3t-0.2-0.5v-2.9q0-0.3 0.2-0.5t0.5-0.2h18.6q0.3 0 0.5 0.2t0.2 0.5v2.2q0 0.4-0.2 0.6t-0.5 0.2h-5.2q1 1.3 1.4 3.2h3.8q0.3 0 0.5 0.2t0.2 0.5z' })
        )
    );
};

exports.default = FaInr;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/inr.js
// module id = 1554
// module chunks = 0